export default "/fonts/vendor/fontsource-roboto/files/roboto-cyrillic-ext-400-normal.woff2?dd55ea0a2e90d5d86e15444a623c385a";